export { default as IntlProvider } from './IntlProvider.js';
//# sourceMappingURL=index.js.map